module.exports = __webpack_public_path__ + "static/media/send_error.1941f1b5.svg";